<template>
  <div id="app">
    <Nav />
    <div class="mt-50 america"></div>
    <div class="app-hz"></div>
    <div class="america-top-ul flex">
      <div
        class="america-top-li"
        v-for="top in touringTop"
        :key="top.id"
        @click="topData(top.id)"
        :class="type == top.id ? 'active' : ''"
      >
        <!-- <div class="top-li-img"></div> -->
        <img class="top-li-img" :src="top.imgUrl" alt="" />
        <div class="top-li-bot flex center">{{ $i18n.locale == 'zh' ? top.title : top.title2}}</div>
      </div>
    </div>
    <div class="america-hz">
      <p class="america-p1">{{ $i18n.locale == 'zh'? touringData.title: touringData.title2}}</p>
      <div class="america-across1"></div>
      <div class="america-across2"></div>
      <img class="mt-20" :src="touringData.imgUrl" alt="" />
      <div class="korea-title mt-10" v-if="type == '1'">
        {{$i18n.locale == 'zh'? '首尔、釜山站巡演曲目' : 'Seoul, Busan Tour Program'}}
      </div>
      <div class="template-tracks flex">
        <div class="template-left" v-if="$i18n.locale == 'zh'">
          <div
            class="america-list"
            v-for="item1 in touringData.chapterList1"
            :key="item1.id"
            :class="item1.type == null ? 'mt-20' : ''"
          >
            <p class="america-p4">{{ item1.title }}</p>
            <p class="america-p5">{{ item1.name }}</p>
            <p class="america-p5">{{ item1.name2 }}</p>
          </div>
        </div>
        <div class="template-right" v-else>
          <div
            class="america-list"
            v-for="item3 in touringData.chapterList2"
            :key="item3.id"
            :class="item3.type == null ? 'mt-20' : ''"
          >
            <p class="america-p4">{{ item3.title }}</p>
            <p class="america-p5">{{ item3.name }}</p>
            <p class="america-p5">{{ item3.name2 }}</p>
          </div>
        </div>
      </div>
      <!-- 韩国 -->
      <div v-if="type == '1'">
        <img class="mt-20" :src="koreaData.imgUrl" alt="" />
        <div class="korea-title mt-10">
          {{$i18n.locale == 'zh'? '南原、光州站巡演曲目' : 'Namwon and Gwangju Tour Program'}}
        </div>
        <div class="template-tracks flex">
          <div class="template-left" v-if="$i18n.locale == 'zh'">
            <div
              class="america-list"
              v-for="item1 in koreaData.chapterList1"
              :key="item1.id"
              :class="item1.type == null ? 'mt-20' : ''"
            >
              <p class="america-p4">{{ item1.title }}</p>
              <p class="america-p5">{{ item1.name }}</p>
              <p class="america-p5">{{ item1.name2 }}</p>
            </div>
          </div>
          <div class="template-right" v-else>
            <div
              class="america-list"
              v-for="item3 in koreaData.chapterList2"
              :key="item3.id"
              :class="item3.type == null ? 'mt-20' : ''"
            >
              <p class="america-p4">{{ item3.title }}</p>
              <p class="america-p5">{{ item3.name }}</p>
              <p class="america-p5">{{ item3.name2 }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 内容 -->
    <div class="template-hz">
      <p class="template-p1">{{ touringData.time }}</p>
      <p class="america-p3 mt-10" v-if="$i18n.locale == 'zh'">
        {{ touringData.content }}
      </p>
      <p class="america-p3 mt-10" v-else>
        {{ touringData.contentEn }}
      </p>
    </div>
    <!-- 图片 -->
    <div class="template-referral flex">
      <div
        class="template-referral-li"
        v-for="ser in touringData.imgList"
        :key="ser.id"
      >
        <img class="referral-li-img" :src="ser.url" alt="" />
        <!-- <p class="referral-li-p">190917金泽市文化厅</p> -->
      </div>
    </div>
    <!-- 视频 -->
    <div class="videoBox">
      <video
        class="video"
        controls
        :poster="touringData.vodImg"
        :src="touringData.vodUrl"
      >
        your browser does not support the video tag
      </video>
    </div>
    <Footer />
  </div>
</template>

<script>
import Nav from "@/components/nav.vue";
import Footer from "@/components/footer.vue";

export default {
  name: "App",
  components: {
    Nav,
    Footer,
  },
  data() {
    return {
      touringTop: [
        {
          id: 0,
          title: "欧洲巡演",
          title2:"Europe tour 2019",
          imgUrl: require("@/assets/tour/tour-60.png"),
          pageurl: "",
        },
        {
          id: 1,
          title: "韩国巡演",
          title2:"South Korea Tour 2019",
          imgUrl: require("@/assets/tour/tour-61.png"),
          pageurl: "",
        },
        {
          id: 2,
          title: "日本巡演",
          title2:"Japan Tour 2019",
          imgUrl: require("@/assets/tour/tour-62.png"),
          pageurl: "",
        },
        {
          id: 3,
          title: "美国巡演",
          title2:"America Tour 2018",
          imgUrl: require("@/assets/tour/tour-63.png"),
          pageurl: "",
        },
        {
          id: 4,
          title: "2023年 欧洲巡演",
          title2:"Europe Tour 2023",
          imgUrl: require("@/assets/tour/tour-64.png"),
          pageurl: "https://www.suco-europe-tour.com/",
        },
        {
          id: 5,
          title: "2024年 日本巡演",
          title2: "Europe Tour 2024",
          imgUrl: require("@/assets/tour/tour-65.png"),
          pageurl: "",
        }
      ],
      touringList: [
        {
          id: 0,
          title: "2019 年“华乐苏韵”欧洲9国13城巡演",
          title2: "2019 'Chinese Music with Suzhoue Charm' Tour in 9 Countries and 13 Cities in Europe",
          imgUrl: require("@/assets/tour/tour-18.png"),
          time: "EUROPE TOUR 2019",
          content:
            "苏州民族管弦乐团于2019年1月15日—2月10日在德国汉堡、施图尔、波恩、德累斯顿、比利时布鲁塞尔、意大利科莫、列支敦士登、瑞士琉森、奥地利蒂罗尔、匈牙利布达佩斯、波兰华沙、俄罗斯圣彼得堡、莫斯科等9个国家13个城市举办《华乐苏韵》大型民族管弦乐音乐会欧洲巡演活动，该巡演既是文化和旅游部主办的“欢乐春节”项目，也是“庆祝中俄建交70周年”“庆祝中波建交70周年”文化交流活动的重要组成部分。音乐会以民族管弦乐、独奏等形式表演《春节序曲》《我的祖国》《茉莉花》《庄周梦》《抒情变奏曲》《二泉映月》《澳门随想曲》等经典作品。苏州民族管弦乐团“欧洲行”历时25天,13场演出跨越9个国家,总行程达2万多公里,有超过1.5万当地民众观看演出。乐团所到之处，各国观众自愿购票观看并热烈追捧，欧洲多家世界知名乐团观摩演出并给予高度评价，海内外主流媒体广泛报道演出盛况，中国驻各国使领馆分别出席活动并致函对乐团为中外文化交流所作贡献表示感谢。",
          contentEn: `The Suzhou Chinese Orchestra had held Europe tour grand concerts “Charm of Chinese Music” in Hamburg, Stuhl, Bonn, Dresden, Brussels, Como, Liechtenstein, Lucerne, Tyrol, Budapest, Warsaw, St. Petersburg and Moscow (13 cities in 9 countries) from January 15 to February 10, 2019, in conjunction with the “Happy Chinese New Year” project by the Ministry of Culture and Tourism of China, and the 70th anniversary of the establishment of diplomatic relations between China and Russia and between China and Poland. The orchestra performed Chinese classical works such as "Spring Festival Overture", "My Motherland", "Jasmine", "Butterfly Dream", "Lyrical Variations", “Er Quan Ying Yue” and "Macau Capriccio". The Suzhou Chinese Orchestra’s Europe tour lasted for 25 days, with 13 concerts spanning across 9 countries and a total travel distance of more than 20,000 kilometers. More than 15,000 local people watched the concerts. Wherever the orchestra went, the concerts were enthusiastically sought after. Many world-renowned orchestras’ members in Europe watched the concerts and gave high praise. The mainstream media at home and abroad reported widely about the grand concerts. Chinese embassies and consulates in various countries attended the event and wrote appreciation letters to express their gratitude to the orchestra for its contribution to cultural exchanges between China and foreign countries.`,
          vodImg: require("@/assets/tour/tour-32.png"),
          vodUrl:
            "https://suco.oss-cn-hangzhou.aliyuncs.com/home/web/005-2.mp4",
          chapterList1: [
            {
              id: 0,
              title: "一、《春节序曲》",
              name: "作曲 李焕之 改编 彭修文",
              name2: "",
            },
            {
              id: 1,
              title: "二、《茉莉花》 或《我的祖国》",
              name: "作曲 刘文金",
              name2: "",
            },
            {
              id: 2,
              title: "三、大提琴协奏曲《庄周梦》",
              name: "作曲 赵季平",
              name2: " 大提琴 康乔瑄（特邀）",
            },
            {
              id: 3,
              title: "——中场休息——",
              name: "",
              name2: "",
            },
            {
              id: 4,
              title: "四、《抒情变奏曲》",
              name: "作曲 刘长远",
              name2: "",
            },
            {
              id: 5,
              title: "五、二胡与乐队《二泉映月》",
              name: "作曲 华彦钧 编曲 朱昌耀",
              name2: " 二胡 朱昌耀",
            },
            {
              id: 6,
              title: "六、《澳门随想曲》",
              name: "作曲 王丹红",
              name2: "",
            },
            {
              id: 7,
              title: "或 《未来的希望》",
              name: "作曲 刘长远",
              name2: "",
              type: 1,
            },
          ],
          chapterList2: [
            {
              id: 1,
              title: '1. "Spring Festival Overture"',
              name: "Composer Li Huanzhi ",
              name2: "Arranged Peng Xiuwen",
            },
            {
              id: 2,
              title: '2. "Jasmine Flower " or " Motherland "',
              name: "Composer Liu Wenjin",
              name2: "",
            },
            {
              id: 3,
              title:
                '3. " Cello Concerto The Butterfly Dream " ',
              name: "Composer Zhao Jiping",
              name2: "Cello Kang Qiaoxuan",
            },
            {
              id: 4,
              title: "——Intermission——",
              name: "",
              name2: "",
            },
            {
              id: 5,
              title: '4. " Lyrical Variation "',
              name: "Composer Liu Changyuan",
              name2: "",
            },
            {
              id: 6,
              title:
                '5. Erhu and Orchestra "Er Quan Ying Yue"',
              name: "Composer Hua Yanjun",
              name2: "Arrangement /Erhu Zhu Changyao",
            },
            {
              id: 7,
              title: '6. " Macau Capriccio "',
              name: "Composer Wang Danhong",
              name2: "",
            },
            {
              id: 8,
              title: 'or " Hope for the future "',
              name: "Composer Liu Changyuan",
              name2: "",
              type: 1,
            },
          ],
          imgList: [
            {
              id: 0,
              url: require("@/assets/tour/tour-19.png"),
              txt: "",
            },
            {
              id: 1,
              url: require("@/assets/tour/tour-20.png"),
              txt: "",
            },
            {
              id: 2,
              url: require("@/assets/tour/tour-21.png"),
              txt: "",
            },
            {
              id: 3,
              url: require("@/assets/tour/tour-22.png"),
              txt: "",
            },
            {
              id: 4,
              url: require("@/assets/tour/tour-23.png"),
              txt: "",
            },
            {
              id: 5,
              url: require("@/assets/tour/tour-24.png"),
              txt: "",
            },
            {
              id: 6,
              url: require("@/assets/tour/tour-25.png"),
              txt: "",
            },
            {
              id: 7,
              url: require("@/assets/tour/tour-26.png"),
              txt: "",
            },
            {
              id: 8,
              url: require("@/assets/tour/tour-27.png"),
              txt: "",
            },
            {
              id: 9,
              url: require("@/assets/tour/tour-28.png"),
              txt: "",
            },
            {
              id: 10,
              url: require("@/assets/tour/tour-29.png"),
              txt: "",
            },
            {
              id: 11,
              url: require("@/assets/tour/tour-30.png"),
              txt: "",
            },
            {
              id: 12,
              url: require("@/assets/tour/tour-31.png"),
              txt: "",
            },
          ],
        },
        {
          id: 2,
          title: "2019 年日本巡演",
          title2: "Japan Tour 2019",
          imgUrl: require("@/assets/tour/tour-17.png"),
          time: "JAPAN TOUR 2019",
          content:
            "为庆祝新中国成立70周年，纪念中日建交47周年，进一步强化对外宣传工作，推动中国文化“走出去”，促进对日经济文化交流合作，根据中央宣传部及省、市党委宣传部对外宣传工作部署以及苏州市、高新区党委政府关于“文化走出去”工作部署，应苏州友好城市日本金泽市政府、日本乐友协会的邀请，苏州民族管弦乐团于2019年9月12日至21日，赴日本开展中日文化交流访演活动，在日本广岛、名古屋、金泽、东京4城市开展为期10天的访演活动。 音乐会由著名指挥家、乐团艺术总监兼首席指挥彭家鹏指挥，著名二胡演奏家、乐团艺术指导朱昌耀，著名昆剧表演艺术家王芳及90多位青年演奏家倾情演绎，表演了《二泉映月》《牡丹亭·游园》《干将·莫邪幻想曲》《澳门随想曲》《抒情变奏曲》《波洛涅兹》等经典曲目。在彭家鹏的激情指挥下，以及朱昌耀、王芳等艺术家的深情演绎下，整场音乐会好曲连台、精彩纷呈，在当地掀起了中国民族交响“中国气派”！乐团所到之处，日本观众自愿购票观看并热烈追捧，日本音乐界的专家学者观摩演出并给予高度评价，中日主流媒体广泛报道演出盛况，日本金泽市政府专门举办接待仪式，中国驻日本国特命全权大使孔铉佑专程发来贺词，中国驻日本使领馆人员出席活动。10天、4座城市、4000多公里行程、跨越日本大半国境……苏州民族管弦乐团用美妙的音乐，收获了日本观众的鲜花与掌声，加深了中国两国之间的文化交流，彰显了新时代中国文化自信。",
          contentEn: `To celebrate the 70th anniversary of the founding of the People’s Republic of China and commemorate the 47th anniversary of the establishment of diplomatic relations between China and Japan, further strengthen external publicity work, promote Chinese culture "Going Global", and promote economic and cultural exchanges and cooperation with Japan, under the work arrangements of Suzhou on "Cultures Going Global", upon invitation by the friendly city Kanazawa Municipal Government and the Japanese Music Friends Association, the Suzhou Chinese Orchestra had successfully held concerts in 4 cities: Hiroshima, Nagoya, Kanazawa dan Tokyo, dated from September 12 to 21, 2019. The concerts were conducted by the renowned conductor, orchestra artistic director and chief conductor Pang Kapang. The famous erhu soloist and orchestra artistic director Zhu Changyao, the famous Kunqu opera performing artist Wang Fang and more than 90 young musicians under the baton of Maestro Pang Kapang gave passionate interpretations of "Er Quan Ying Yue", "Peony Pavilion · Strolling in the Garden", "Fantasia of Gan Jiang Mo Ye", "Macau Capriccio", "Lyrical Variations", "Polonaise from 'Eugene Onegin' " and other classics. The concerts were brilliant, creating a wave of the Chinese national symphony "Chinese style" in the local area. Wherever the orchestra went, the concerts were enthusiastically sought after. Experts and critics in the Japanese music industry watched and spoke highly of the performance. The mainstream media of China and Japan reported widely about the concerts. The Kanazawa City Government held a reception ceremony. Kong Xuanyou, Chinese ambassador to Japan, sent a special congratulatory message, and the Chinese embassy in Japan attended the event. 10 days, 4 cities, more than 4,000 kilometers of travel, spanning most of Japan... The Suzhou Chinese Orchestra played wonderful music and received flowers and applause from Japanese audiences, such concerts had deepened the cultural relationship between China and Japan, and showed the Chinese cultural confidence in the new era.`,
          vodImg: require("@/assets/tour/tour-33.png"),
          vodUrl: "https://suco.oss-cn-hangzhou.aliyuncs.com/home/web/003.mp4",
          chapterList1: [
            {
              id: 0,
              title: "一、《奔腾》",
              name: "作曲 谢鹏 朱昌耀",
              name2: "",
            },
            {
              id: 1,
              title: "二、《牡丹亭 · 游园》",
              name: "编曲 朱昌耀",
              name2: "昆曲演唱 王芳",
            },
            {
              id: 2,
              title: "三、《波罗涅兹》",
              name: "作曲 柴可夫斯基",
              name2: "改编 汪磊",
            },
            {
              id: 3,
              title: "四、《随想曲》",
              name: "作曲 王丹红",
              name2: "",
            },
            {
              id: 4,
              title: "——中场休息——",
              name: "",
              name2: "",
            },
            {
              id: 5,
              title: "五、《抒情变奏曲》",
              name: "作曲 刘长远 华彦钧",
              name2: "",
            },
            {
              id: 6,
              title: "六、《二泉映月》二胡 与乐队",
              name: "作曲 华彦钧",
              name2: "编曲 / 二胡独奏 朱昌耀",
            },
            {
              id: 7,
              title: "七《干将 · 莫邪幻想曲》",
              name: "作曲 张朝",
              name2: "",
            },
          ],
          chapterList2: [
            {
              id: 1,
              title: "1.Surging Forward",
              name: "Composer Xie Peng",
              name2: "Zhu Changyao",
            },
            {
              id: 2,
              title: "2.Peony Pavilion · Strolling in the Garden",
              name: "Arrangement Zhu Changyao",
              name2: "Kun Opera performed Wang Fang",
            },
            {
              id: 3,
              title: "3.Polonaise",
              name: "Composer Tchaikovsky Adapted by Wang Lei",
              name2: "",
            },
            {
              id: 4,
              title: "4.Macau Capriccio",
              name: "Wang Danhong",
              name2: "Adapted Wang Lei",
            },
            {
              id: 5,
              title: "——Intermission——",
              name: "",
              name2: "",
            },
            {
              id: 6,
              title: "5.Lyrical Variations",
              name: "Composer Liu Changyuan",
              name2: "Hua Yanjun",
            },
            {
              id: 7,
              title: "6.Er Quan Ying Yue ",
              name: "Composer Hua Yanjun",
              name2: "Arrangement Zhu Changyao Erhu solo Zhu Changyao",
            },
            {
              id: 8,
              title: "7.Fantasia Gan Jiang Mo Ye",
              name: "Composer Zhang Zhao",
              name2: "",
            },
          ],
          imgList: [
            {
              id: 0,
              url: require("@/assets/tour/tour-35.png"),
              txt: "",
            },
            {
              id: 1,
              url: require("@/assets/tour/tour-36.png"),
              txt: "",
            },
            {
              id: 2,
              url: require("@/assets/tour/tour-37.png"),
              txt: "",
            },
            {
              id: 3,
              url: require("@/assets/tour/tour-38.png"),
              txt: "",
            },
            {
              id: 4,
              url: require("@/assets/tour/tour-39.png"),
              txt: "",
            },
            {
              id: 5,
              url: require("@/assets/tour/tour-40.png"),
              txt: "",
            },
            {
              id: 6,
              url: require("@/assets/tour/tour-41.png"),
              txt: "",
            },
            {
              id: 7,
              url: require("@/assets/tour/tour-42.png"),
              txt: "",
            },
            {
              id: 8,
              url: require("@/assets/tour/tour-43.png"),
              txt: "",
            },
            {
              id: 9,
              url: require("@/assets/tour/tour-44.png"),
              txt: "",
            },
            {
              id: 10,
              url: require("@/assets/tour/tour-45.png"),
              txt: "",
            },
            {
              id: 11,
              url: require("@/assets/tour/tour-46.png"),
              txt: "",
            },
            {
              id: 12,
              url: require("@/assets/tour/tour-47.png"),
              txt: "",
            },
          ],
        },
        {
          id: 1,
          title: "2019年韩国巡演",
          title2:"South Korea tour 2019", 
          imgUrl: require("@/assets/tour/tour-48.png"),
          time: "KOREA TOUR 2019",
          content:
            "为庆祝新中国成立70周年，纪念中韩建交27周年，进一步推动苏州文化“走出去”，应韩国音乐协会、中国音乐家协会共同邀请，作为第36届韩国国际音乐节唯一一个受邀的中国乐团，在韩国首尔、南原、光州、釜山4城市举办“韩国国际音乐节·中国音乐之夜”专场音乐会，为期8天。",
          contentEn: `In order to celebrate the 70th anniversary of the founding of the People’s Republic of China, to commemorate the 27th anniversary of the establishment of diplomatic relations between China and South Korea and to further promote the "Going Global" of Suzhou culture, upon the invitation of the Korean Music Association and the Chinese Musicians Association, Suzhou Chinese Orchestra as the only China’s orchestra being invited to the 36th Korea International Music Festival had held special concerts of "Korea International Music Festival·Chinese Music Night" in 4 cities (Seoul, Namwon, Gwangju and Busan) within 8 days.`,
          vodImg: require("@/assets/tour/tour-34.png"),
          vodUrl: "https://suco.oss-cn-hangzhou.aliyuncs.com/home/web/004.mp4",
          chapterList1: [
            {
              id: 0,
              title: "一、《烟雨枫桥》",
              name: "作曲：李滨扬",
              name2: "",
            },
            {
              id: 1,
              title: "二、钢琴协奏曲《黄河》",
              name: "作曲 殷承宗、储望华、 盛礼洪、刘庄",
              name2: "改编 刘文金 钢琴 李莲花（特邀韩国钢琴家）",
            },
            {
              id: 2,
              title: "——中场休息 ——",
              name: "",
              name2: "",
            },
            {
              id: 3,
              title: "三、《抒情变奏曲》",
              name: "作曲 刘长远",
              name2: "",
            },
            {
              id: 4,
              title: "四、《二泉映月》",
              name: "作曲 华彦钧",
              name2: "编曲 朱昌耀 二胡 朱昌耀",
            },
            {
              id: 5,
              title: "五、《干将·莫邪幻想曲》",
              name: "作曲 张朝",
              name2: "",
            },
          ],
          chapterList2: [
            {
              id: 1,
              title: "1.Misty Rain on Maple Bridge",
              name: "Composer Li Binyang",
              name2: "",
            },
            {
              id: 2,
              title: "2.Piano Concerto Yellow River",
              name: "Composer Yin Chengzong, Chu Wanghua, Sheng Lihong, Liu Zhuang",
              name2: " Transcribed Liu Wenjin. Piano Youn-Wha Lee (Korea)",
            },
            {
              id: 3,
              title: "——Intermission——",
              name: "",
              name2: "",
            },
            {
              id: 4,
              title: "3.Variations of Emotions",
              name: "Composer Liu Changyuan",
              name2: "",
            },
            {
              id: 5,
              title: "4.Er Quan Ying Yue",
              name: "Composer Hua Yanjun,",
              name2: "Arrangement Zhu Changyao Erhu Zhu Changyao",
            },
            {
              id: 6,
              title: "5.Gan Jiang Mo Ye Fantasy",
              name: "Composer Zhang Zhao",
              name2: "",
            },
          ],
          imgList: [
            {
              id: 0,
              url: require("@/assets/tour/tour-50.png"),
              txt: "",
            },
            {
              id: 1,
              url: require("@/assets/tour/tour-51.png"),
              txt: "",
            },
            {
              id: 2,
              url: require("@/assets/tour/tour-52.png"),
              txt: "",
            },
            {
              id: 3,
              url: require("@/assets/tour/tour-53.png"),
              txt: "",
            },
            {
              id: 4,
              url: require("@/assets/tour/tour-54.png"),
              txt: "",
            },
            {
              id: 5,
              url: require("@/assets/tour/tour-55.png"),
              txt: "",
            },
            {
              id: 6,
              url: require("@/assets/tour/tour-56.png"),
              txt: "",
            },
            {
              id: 7,
              url: require("@/assets/tour/tour-57.png"),
              txt: "",
            },
            {
              id: 8,
              url: require("@/assets/tour/tour-58.png"),
              txt: "",
            },
            {
              id: 9,
              url: require("@/assets/tour/tour-59.png"),
              txt: "",
            },
          ],
        },
      ],
      koreaData: {
        imgUrl: require("@/assets/tour/tour-49.png"),
        chapterList1: [
          {
            id: 0,
            title: "一、交响诗《四季留园》",
            name: "作曲 王丹红",
            name2: "",
          },
          {
            id: 1,
            title: "——中场休息 ——",
            name: "",
            name2: "",
          },
          {
            id: 2,
            title: "二、《抒情变奏曲》",
            name: "作曲 刘长远",
            name2: "",
          },
          {
            id: 3,
            title: "三、《二泉映月》",
            name: "作曲 华彦钧",
            name2: "编曲 朱昌耀 二胡 朱昌耀",
          },
          {
            id: 4,
            title: "四、《干将·莫邪幻想曲》",
            name: "作曲 张朝",
            name2: "",
          },
        ],
        chapterList2: [
          {
            id: 1,
            title: "1.Symphonic Poem Four Seasons in Lingering Garden",
            name: "Composer Wang Danhong",
            name2: "",
          },
          {
            id: 2,
            title: "——Intermission——",
            name: "",
            name2: "",
          },
          {
            id: 3,
            title: "2.Lyrical Variations",
            name: "Composer Liu Changyuan",
            name2: "",
          },
          {
            id: 4,
            title: "3.Er Quan Ying Yue",
            name: "Composer Hua Yanjun,",
            name2: "Arrangement Zhu Changyao Erhu Zhu Changyao",
          },
          {
            id: 5,
            title: "4.Fantasia od Gan Jiang Mo Ye",
            name: "Composer Zhang Zhao",
          },
        ],
      },
      type: 0,
      touringData: {},
    };
  },
  computed: {},
  created() {
    // this.getInitData();
    this.type = this.$route.query.type || 0;
    this.topData(this.type)
  },
  mounted() {},
  methods: {
    //  头部导航
    topData(index) {
      this.type = index;
      if (index == "3") {
         this.$router.push({ name: "Usshow" });
      } else if (index == "4") {
         this.$router.push({ name: "Europe" });
      } else if (index == "5") {
         this.$router.push({ name: "Japan" });
      } else {
        let ser = this.touringList.filter((item) => {
          if (index == item.id) {
            return item;
          }
        });
        this.touringData = ser[0] || {};
      }
    },
  },
};
</script>



<style lang="scss" scoped>
#app {
  background-color: #f2f6f7;
  img {
    max-width: 100%;
  }
}
.america {
  overflow: hidden;
}
.app-hz{
  width: 100%;
  height: 15px;
}
.america-top-ul {
  width: 100%;
  height: 90px;
  // margin-top: 15px;
  padding-left: 16px;
  box-sizing: border-box;
  overflow-y: hidden;
  overflow-x: auto;
  .america-top-li {
    width: 88px;
    height: 90px;
    background: transparent;
    margin-right: 12px;
    flex-shrink: 0;
    .top-li-img {
      width: 100%;
      height: 50px;
      display: block;
    }
    .top-li-bot {
      width: 100%;
      height: 38px;
      padding: 0 6px;
      line-height: 16px;
      box-sizing: border-box;
      font-size: 13px;
      color: #666666;
      border: 1px solid #835c46;
      border-radius: 0 0 18px 0;
      text-align: center;
    }
  }
  .active {
    .top-li-bot {
      font-size: 13px;
      color: #fff;
      background-color: #835c46;
    }
  }
}
.america-p1 {
  font-size: 20px;
  color: #444444;
  line-height: 40px;
  font-weight: 400;
}
.america-p2 {
  margin: 4px 0 6px;
  font-size: 18px;
  color: #634636;
  line-height: 26px;
}
.america-p3 {
  font-size: 11px;
  color: #444444;
  line-height: 16px;
  font-weight: 300;
}
.america-p4 {
  font-size: 12px;
  color: #333333;
  line-height: 18px;
  font-weight: 400;
}
.america-p5 {
  font-size: 12px;
  color: #333333;
  line-height: 18px;
  font-weight: 300;
}
.america-p6 {
  font-size: 12px;
  color: #ffffff;
  font-weight: 400;
  //   text-align: center;
  line-height: 18px;
}
.america-hz {
  padding: 20px 16px 20px;

  .america-across1 {
    width: 100%;
    height: 2px;
    background-color: #c8c2bd;
  }
  .america-across2 {
    margin-top: 2px;
    width: 100%;
    height: 1px;
    background-color: #c8c2bd;
  }

  .america-title {
    margin-top: 24px;
    .america-title-left {
      width: 100px;
      height: 30px;
      line-height: 30px;
      padding-left: 11px;
      box-sizing: border-box;
      color: #634636;
      background: linear-gradient(
        90deg,
        #b49a71 0%,
        rgba(180, 154, 113, 0) 100%
      );
    }
    .america-title-right {
      width: 218px;
      height: 36px;
    }
  }
  .template-tracks {
    .template-left {
      // width: 42%;
      //   height: 10px;
      margin-right: 16px;
    }
    // .template-right {
      // width: 56%;
      //   height: 10px;
    // }
  }
  .america-list {
    position: relative;
  }
}
.template-hz {
  width: 100%;
  background-color: #ffffff;
  border-radius: 50px 0 50px 0;
  padding: 26px 16px;
  box-sizing: border-box;
}
.template-p1 {
  font-size: 24px;
  font-family: Roboto, Roboto-Regular;
  font-weight: 400;
  text-shadow: rgba(0, 0, 0, 0.3) 1px 0 0, rgba(0, 0, 0, 0.3) 0 1px 0,
    rgba(0, 0, 0, 0.3) -1px 0 0, rgba(0, 0, 0, 0.3) 0 -1px 0;
  color: #fff;
}
.template-referral {
  margin: 24px 0;
  width: 100%;
  padding-left: 16px;
  box-sizing: border-box;
  overflow-y: hidden;
  overflow-x: auto;
  .template-referral-li {
    position: relative;
    flex-shrink: 0;
    .referral-li-img {
      width: 181px;
      height: 125px;
      margin-right: 8px;
    }
    .referral-li-p {
      position: absolute;
      right: 8px;
      bottom: 7px;
      padding: 3px 6px;
      background-color: rgba(235, 97, 0, 0.5);
      color: #ffffff;
      font-size: 10px;
      line-height: 14px;
      box-sizing: border-box;
    }
  }
}
.videoBox {
  width: 100%;
  height: 180px;
  margin-bottom: 46px;
  .video {
    width: 100%;
  }
}
.korea-title {
  // width: 152px;
  display: inline-block;
  padding-left: 12px;
  font-size: 14px;
  color: #634636;
  line-height: 30px;
  background: linear-gradient(90deg, #b49a71 0%, rgba(180, 154, 113, 0) 100%);
}
</style>
